
import { AmbienteExterno } from '../types/negocio/AmbienteExterno';
import api from './api';
import BaseService from './BaseService';

class AmbienteExternoService extends BaseService<AmbienteExterno> {

    constructor() {
        super('ambiente-externo', api);
    }

    async listarTodosPorTipo(tipo: string): Promise<AmbienteExterno[]> {
        try {
            const response = (await this.api.get<AmbienteExterno[]>(`/api/${this.route}/tipo/${tipo}`)).data;
            return response;
        } catch (error) {
            console.error('Error fetching data by type:', error);
            throw error;
        }
    }

}

export const ambienteExternoService = new AmbienteExternoService();